"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.receiveLocalePrefixConfig=function(e){return"object"==typeof e?e:{mode:e||"always"}};
